export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";